var _style, _g, _path, _g2, _rect, _path2, _path3, _rect2, _g3, _path4, _path5, _path6, _path7, _rect3, _path8, _g4, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _rect4, _path32, _polygon, _path33, _polygon2, _path34, _path35, _g5, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g6, _g7, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolutionBpm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x2014_\\xCE\\xD3\\xC8_x5F_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 458.99 294.62",
    style: {
      enableBackground: "new 0 0 458.99 294.62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.3;fill:#F49E7E;enable-background:new    ;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#F49E7E;}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:url(#SVGID_4_);}\n\t.st6{opacity:0.3;enable-background:new    ;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{fill:url(#SVGID_5_);}\n\t.st9{fill:url(#SVGID_6_);}\n\t.st10{fill:url(#SVGID_7_);}\n\t.st11{fill:url(#SVGID_8_);}\n\t.st12{opacity:0.1;enable-background:new    ;}\n\t.st13{fill:#AFD4C2;}\n\t.st14{opacity:0.2;enable-background:new    ;}\n\t.st15{fill:#FDB592;}\n\t.st16{fill:url(#SVGID_9_);}\n\t.st17{fill:url(#SVGID_10_);}\n\t.st18{fill:url(#SVGID_11_);}\n\t.st19{fill:url(#SVGID_12_);}\n\t.st20{fill:url(#SVGID_13_);}\n\t.st21{fill:url(#SVGID_14_);}\n\t.st22{fill:url(#SVGID_15_);}\n\t.st23{fill:url(#SVGID_16_);}\n\t.st24{fill:url(#SVGID_17_);}\n\t.st25{fill:url(#SVGID_18_);}\n\t.st26{fill:url(#SVGID_19_);}\n\t.st27{fill:url(#SVGID_20_);}\n\t.st28{fill:url(#SVGID_21_);}\n\t.st29{fill:url(#SVGID_22_);}\n\t.st30{fill:url(#SVGID_23_);}\n\t.st31{fill:url(#SVGID_24_);}\n\t.st32{fill:url(#SVGID_25_);}\n\t.st33{fill:url(#SVGID_26_);}\n\t.st34{fill:url(#SVGID_27_);}\n\t.st35{fill:url(#SVGID_28_);}\n\t.st36{fill:url(#SVGID_29_);}\n\t.st37{fill:url(#SVGID_30_);}\n\t.st38{fill:url(#SVGID_31_);}\n\t.st39{fill:url(#SVGID_32_);}\n\t.st40{fill:url(#SVGID_33_);}\n\t.st41{fill:url(#SVGID_34_);}\n\t.st42{fill:url(#SVGID_35_);}\n\t.st43{fill:url(#SVGID_36_);}\n\t.st44{fill:url(#SVGID_37_);}\n\t.st45{fill:url(#SVGID_38_);}\n\t.st46{fill:url(#SVGID_39_);}\n\t.st47{fill:url(#SVGID_40_);}\n\t.st48{fill:url(#SVGID_41_);}\n\t.st49{fill:#FDCEDC;}\n\t.st50{fill:url(#SVGID_42_);}\n\t.st51{fill:#6B6966;}\n\t.st52{fill:url(#SVGID_43_);}\n\t.st53{opacity:0.5;enable-background:new    ;}\n\t.st54{fill:url(#SVGID_44_);}\n\t.st55{fill:url(#SVGID_45_);}\n\t.st56{opacity:0.68;fill:#F49E7E;enable-background:new    ;}\n\t.st57{fill:#E2BCB7;}\n\t.st58{fill:url(#SVGID_46_);}\n\t.st59{fill:url(#SVGID_47_);}\n\t.st60{fill:url(#SVGID_48_);}\n\t.st61{fill:url(#SVGID_49_);}\n\t.st62{fill:url(#SVGID_50_);}\n\t.st63{fill:url(#SVGID_51_);}\n\t.st64{fill:url(#SVGID_52_);}\n\t.st65{fill:url(#SVGID_53_);}\n\t.st66{fill:#A66737;}\n\t.st67{fill:url(#SVGID_54_);}\n\t.st68{fill:url(#SVGID_55_);}\n\t.st69{fill:url(#SVGID_56_);}\n\t.st70{fill:url(#SVGID_57_);}\n\t.st71{opacity:0.19;enable-background:new    ;}\n\t.st72{fill:url(#SVGID_58_);}\n\t.st73{fill:url(#SVGID_59_);}\n\t.st74{fill:url(#SVGID_60_);}\n\t.st75{fill:url(#SVGID_61_);}\n\t.st76{fill:url(#SVGID_62_);}\n\t.st77{fill:url(#SVGID_63_);}\n\t.st78{fill:url(#SVGID_64_);}\n\t.st79{fill:url(#SVGID_65_);}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M458.99,291.62V49.63c-48.08,2.54-105.91,12.45-144.58,51.13c-54.43,54.43-57.79,110.42-108.44,110.42 c-51.05,0-63.2,51.11-92.15,83.45H456C457.65,294.62,458.99,293.28,458.99,291.62z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -281.0274,
    y1: 2567.6086,
    x2: -90.962,
    y2: 2567.6086,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -995.3378 -2048.9963)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M407.8,114.98v92.2c0,0.52-0.09,1.03-0.25,1.5c-0.62,1.79-2.33,3.09-4.34,3.09H246.94 c-2.53,0-4.59-2.06-4.59-4.59v-92.2c0-2.54,2.06-4.6,4.59-4.6h156.27C405.75,110.38,407.8,112.44,407.8,114.98z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M247.82,200.04c-1.52,0-2.76-1.23-2.76-2.76v-81.44c0-1.52,1.23-2.76,2.76-2.76h154.53 c1.52,0,2.75,1.23,2.75,2.76v81.44c0,1.52-1.23,2.76-2.75,2.76H247.82z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -203.9458,
    y1: 2632.0339,
    x2: -168.029,
    y2: 2632.0339,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1032.2938 -2037.3396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 312.78,
    y: 211.76,
    className: "st3",
    width: 24.6,
    height: 27.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -206.8328,
    y1: 2646.0498,
    x2: -165.2385,
    y2: 2646.0498,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1040.3436 -2034.8339)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M348.54,241.06h-47.02c-0.85,0-1.54-0.69-1.54-1.54l0,0c0-0.85,0.69-1.54,1.54-1.54h47.02 c0.85,0,1.54,0.69,1.54,1.54l0,0C350.07,240.38,349.39,241.06,348.54,241.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -187.441,
    y1: 2612.3564,
    x2: -184.528,
    y2: 2612.3564,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1021.0029 -2040.8992)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M323.63,205.82c0-0.8,0.65-1.46,1.46-1.46c0.8,0,1.46,0.65,1.46,1.46s-0.65,1.46-1.46,1.46 C324.28,207.28,323.63,206.63,323.63,205.82z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 312.78,
    y: 211.76,
    className: "st6",
    width: 24.6,
    height: 3.36
  })), /*#__PURE__*/React.createElement("g", null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M391.16,86.92v113.12H258.91V86.92c0-2.55,2.07-4.62,4.62-4.62h123C389.09,82.29,391.16,84.36,391.16,86.92 z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: -243.4498,
    y1: 2495.4067,
    x2: -130.4409,
    y2: 2495.4067,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -953.4108 -2062.2429)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M391.16,93.63H258.91v-6.72c0-2.55,2.07-4.62,4.62-4.62h123c2.55,0,4.62,2.07,4.62,4.62v6.72H391.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -126.8122,
    y1: 2494.4958,
    x2: -125.1707,
    y2: 2494.4958,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -942.5505 -2027.7996)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8CCD6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M384.26,87.96c0-0.45,0.37-0.82,0.82-0.82s0.82,0.37,0.82,0.82s-0.37,0.82-0.82,0.82 C384.63,88.79,384.26,88.42,384.26,87.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: -129.7975,
    y1: 2494.5,
    x2: -128.1563,
    y2: 2494.5,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -943.0909 -2029.5131)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8CCD6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M381.28,87.96c0-0.45,0.37-0.82,0.82-0.82s0.82,0.37,0.82,0.82s-0.37,0.82-0.82,0.82 C381.64,88.79,381.28,88.42,381.28,87.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: -132.7847,
    y1: 2494.4978,
    x2: -131.1432,
    y2: 2494.4978,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -943.6307 -2031.226)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8CCD6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M378.29,87.96c0-0.45,0.37-0.82,0.82-0.82s0.82,0.37,0.82,0.82s-0.37,0.82-0.82,0.82 C378.66,88.79,378.29,88.42,378.29,87.96z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 388.16,
    y: 93.63,
    className: "st12",
    width: 2.99,
    height: 106.41
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M389.66,149.15L389.66,149.15c-0.83,0-1.5-0.67-1.5-1.5v-9.88c0-0.83,0.67-1.5,1.5-1.5l0,0 c0.83,0,1.5,0.67,1.5,1.5v9.88C391.16,148.48,390.49,149.15,389.66,149.15z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M344.56,90.47h-80.03c-1.31,0-2.37-1.06-2.37-2.37l0,0c0-1.31,1.06-2.37,2.37-2.37h80.03 c1.31,0,2.37,1.06,2.37,2.37l0,0C346.93,89.41,345.87,90.47,344.56,90.47z"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M265.69,109.13c0,0.77-0.03,1.54-0.1,2.32c-0.02,0.09-0.02,0.19-0.03,0.28c-0.51,6.01-2.92,11.51-6.59,15.91 l-0.19,0.23c-0.99,1.18-2.08,2.26-3.27,3.26c-0.07,0.07-0.14,0.12-0.22,0.18c-3.66,3.08-8.08,5.25-12.94,6.19V80.77 c4.86,0.94,9.28,3.11,12.94,6.18c0.08,0.07,0.15,0.12,0.22,0.18c1.19,1.01,2.28,2.09,3.27,3.27l0.19,0.23 c3.67,4.39,6.08,9.89,6.59,15.91c0.01,0.09,0.01,0.19,0.03,0.28C265.66,107.59,265.69,108.36,265.69,109.13z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M341.48,158.62h-69.67c-1.65,0-3-1.35-3-3v-49.67c0-1.65,1.35-3,3-3h69.67c1.65,0,3,1.35,3,3v49.67 C344.48,157.27,343.13,158.62,341.48,158.62z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M375.29,158.62h-18.31c-1.65,0-3-1.35-3-3v-49.67c0-1.65,1.35-3,3-3h18.31c1.65,0,3,1.35,3,3v49.67 C378.29,157.27,376.94,158.62,375.29,158.62z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M344.48,170.7v17.73c0,1.65-1.35,3-3,3h-69.67c-1.65,0-3-1.35-3-3V170.7c0-1.65,1.35-3,3-3h69.67 C343.13,167.7,344.48,169.05,344.48,170.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M378.29,170.7v17.73c0,1.65-1.35,3-3,3h-18.31c-1.65,0-3-1.35-3-3V170.7c0-1.65,1.35-3,3-3h18.31 C376.94,167.7,378.29,169.05,378.29,170.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: -239.9522,
    y1: 2537.3245,
    x2: -218.9037,
    y2: 2537.3245,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -985.8204 -2079.386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M281.64,148.82c-0.24,0-0.43-0.2-0.43-0.43v-35.2c0-0.24,0.19-0.43,0.43-0.43s0.43,0.19,0.43,0.43v35.2 C282.08,148.63,281.88,148.82,281.64,148.82z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M283.27,124.29h-3.25c-1.1,0-2-0.9-2-2l0,0c0-1.11,0.9-2,2-2h3.25c1.1,0,2,0.89,2,2l0,0 C285.27,123.39,284.37,124.29,283.27,124.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: -232.754,
    y1: 2527.8262,
    x2: -226.0936,
    y2: 2527.8262,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -980.3718 -2081.1042)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M283.27,123.29h-3.25c-1.1,0-2-0.9-2-2l0,0c0-1.11,0.9-2,2-2h3.25c1.1,0,2,0.89,2,2l0,0 C285.27,122.39,284.37,123.29,283.27,123.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: -229.9524,
    y1: 2537.3245,
    x2: -208.9039,
    y2: 2537.3245,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -984.0123 -2073.6501)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M291.64,148.82c-0.24,0-0.43-0.2-0.43-0.43v-35.2c0-0.24,0.19-0.43,0.43-0.43s0.43,0.19,0.43,0.43v35.2 C292.08,148.63,291.88,148.82,291.64,148.82z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M293.27,134.29h-3.25c-1.1,0-2-0.9-2-2l0,0c0-1.11,0.9-2,2-2h3.25c1.1,0,2,0.89,2,2l0,0 C295.27,133.39,294.37,134.29,293.27,134.29z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M293.27,133.29h-3.25c-1.1,0-2-0.9-2-2l0,0c0-1.11,0.9-2,2-2h3.25c1.1,0,2,0.89,2,2l0,0 C295.27,132.39,294.37,133.29,293.27,133.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: -219.9529,
    y1: 2537.3242,
    x2: -198.9044,
    y2: 2537.3242,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -982.2037 -2067.9143)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M301.64,148.82c-0.24,0-0.43-0.2-0.43-0.43v-35.2c0-0.24,0.19-0.43,0.43-0.43s0.43,0.19,0.43,0.43v35.2 C302.08,148.63,301.88,148.82,301.64,148.82z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M303.27,144.29h-3.25c-1.1,0-2-0.9-2-2l0,0c0-1.11,0.9-2,2-2h3.25c1.1,0,2,0.89,2,2l0,0 C305.27,143.39,304.37,144.29,303.27,144.29z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M303.27,143.29h-3.25c-1.1,0-2-0.9-2-2l0,0c0-1.11,0.9-2,2-2h3.25c1.1,0,2,0.89,2,2l0,0 C305.27,142.39,304.37,143.29,303.27,143.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: -209.9538,
    y1: 2537.3245,
    x2: -188.9053,
    y2: 2537.3245,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -980.3951 -2062.179)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M311.64,148.82c-0.24,0-0.43-0.2-0.43-0.43v-35.2c0-0.24,0.19-0.43,0.43-0.43s0.43,0.19,0.43,0.43v35.2 C312.08,148.63,311.88,148.82,311.64,148.82z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M313.27,128.29h-3.25c-1.1,0-2-0.9-2-2l0,0c0-1.11,0.9-2,2-2h3.25c1.1,0,2,0.89,2,2l0,0 C315.27,127.39,314.37,128.29,313.27,128.29z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M313.27,127.29h-3.25c-1.1,0-2-0.9-2-2l0,0c0-1.11,0.9-2,2-2h3.25c1.1,0,2,0.89,2,2l0,0 C315.27,126.39,314.37,127.29,313.27,127.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: -199.9542,
    y1: 2537.3242,
    x2: -178.9057,
    y2: 2537.3242,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -978.5867 -2056.4431)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M321.64,148.82c-0.24,0-0.43-0.2-0.43-0.43v-35.2c0-0.24,0.19-0.43,0.43-0.43s0.43,0.19,0.43,0.43v35.2 C322.08,148.63,321.88,148.82,321.64,148.82z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M323.27,124.29h-3.25c-1.1,0-2-0.9-2-2l0,0c0-1.11,0.9-2,2-2h3.25c1.1,0,2,0.89,2,2l0,0 C325.27,123.39,324.37,124.29,323.27,124.29z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M323.27,123.29h-3.25c-1.1,0-2-0.9-2-2l0,0c0-1.11,0.9-2,2-2h3.25c1.1,0,2,0.89,2,2l0,0 C325.27,122.39,324.37,123.29,323.27,123.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: -189.9547,
    y1: 2537.324,
    x2: -168.9062,
    y2: 2537.324,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -976.7781 -2050.7073)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M331.64,148.82c-0.24,0-0.43-0.2-0.43-0.43v-35.2c0-0.24,0.19-0.43,0.43-0.43s0.43,0.19,0.43,0.43v35.2 C332.08,148.63,331.88,148.82,331.64,148.82z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M333.27,138.29h-3.25c-1.1,0-2-0.9-2-2l0,0c0-1.11,0.9-2,2-2h3.25c1.1,0,2,0.89,2,2l0,0 C335.27,137.39,334.37,138.29,333.27,138.29z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M333.27,137.29h-3.25c-1.1,0-2-0.9-2-2l0,0c0-1.11,0.9-2,2-2h3.25c1.1,0,2,0.89,2,2l0,0 C335.27,136.39,334.37,137.29,333.27,137.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: -245.7825,
    y1: 2487.3191,
    x2: -234.6402,
    y2: 2487.3191,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -994.9501 -2105.9221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    style: {
      stopColor: "#A5CBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6815,
    style: {
      stopColor: "#8CB4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 231.46,
    y: 64.81,
    className: "st23",
    width: 7.07,
    height: 9.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: -245.4975,
    y1: 2481.626,
    x2: -234.9148,
    y2: 2481.626,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -991.6846 -2106.9495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    style: {
      stopColor: "#A5CBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6815,
    style: {
      stopColor: "#8CB4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M230.24,62.11h9.52c0.56,0,1.02,0.46,1.02,1.02v1.3c0,0.56-0.46,1.02-1.02,1.02h-9.52 c-0.57,0-1.02-0.46-1.02-1.02v-1.3C229.22,62.57,229.68,62.11,230.24,62.11z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: -262.4269,
    y1: 2495.2686,
    x2: -257.6459,
    y2: 2495.2686,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1003.0958 -2115.8582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    style: {
      stopColor: "#A5CBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6815,
    style: {
      stopColor: "#8CB4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st25",
    points: "211.94,76.98 214.72,74.19 218.4,77.87 215.61,80.66  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: -265.53,
    y1: 2493.0291,
    x2: -259.0387,
    y2: 2493.0291,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1002.2125 -2117.551)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    style: {
      stopColor: "#A5CBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6815,
    style: {
      stopColor: "#8CB4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M210.39,76.4l3.75-3.75c0.22-0.22,0.58-0.22,0.81,0l0.51,0.51c0.22,0.22,0.22,0.58,0,0.81l-3.75,3.75 c-0.22,0.22-0.58,0.22-0.81,0l-0.51-0.51C210.17,76.98,210.17,76.62,210.39,76.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: -223.2783,
    y1: 2495.2705,
    x2: -217.4682,
    y2: 2495.2705,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -995.9224 -2093.1067)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    style: {
      stopColor: "#A5CBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6815,
    style: {
      stopColor: "#8CB4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "258.07,76.98 255.28,74.19 251.6,77.87 254.39,80.66  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: -219.519,
    y1: 2493.0271,
    x2: -216.7417,
    y2: 2493.0271,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -994.228 -2092.2258)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    style: {
      stopColor: "#A5CBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6815,
    style: {
      stopColor: "#8CB4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M259.61,76.4l-3.75-3.75c-0.22-0.22-0.58-0.22-0.81,0l-0.51,0.51c-0.22,0.22-0.22,0.58,0,0.81l3.75,3.75 c0.22,0.22,0.58,0.22,0.81,0l0.51-0.51C259.84,76.98,259.84,76.62,259.61,76.4z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: -267.9359,
    y1: 2514.9448,
    x2: -212.4764,
    y2: 2514.9448,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1010.7938 -2100.9246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    style: {
      stopColor: "#A5CBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6815,
    style: {
      stopColor: "#8CB4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M235,69.37c-15.31,0-27.73,12.42-27.73,27.73s12.42,27.73,27.73,27.73c15.32,0,27.73-12.42,27.73-27.73 S250.32,69.37,235,69.37z M251.8,111.41c-0.76,0.9-1.6,1.73-2.5,2.5c-3.43,2.93-7.77,4.83-12.53,5.19 c-0.58,0.05-1.18,0.08-1.77,0.08c-0.59,0-1.19-0.03-1.76-0.08c-4.76-0.37-9.09-2.26-12.53-5.2c-0.91-0.76-1.75-1.6-2.5-2.5 c-2.94-3.43-4.83-7.77-5.2-12.53c-0.05-0.58-0.08-1.17-0.08-1.76c0-0.59,0.03-1.18,0.08-1.76c0.37-4.77,2.26-9.1,5.2-12.53 c0.75-0.9,1.59-1.74,2.5-2.5c3.44-2.94,7.78-4.83,12.53-5.2c0.58-0.05,1.17-0.08,1.76-0.08s1.19,0.03,1.77,0.08 c4.77,0.37,9.1,2.26,12.53,5.19c0.9,0.77,1.74,1.6,2.5,2.5c2.93,3.44,4.84,7.78,5.2,12.54c0.05,0.58,0.08,1.17,0.08,1.76 c0,0.59-0.03,1.18-0.08,1.76C256.63,103.63,254.73,107.97,251.8,111.41z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M257.5,97.1c0,0.6-0.02,1.2-0.08,1.8c-0.01,0.07-0.01,0.15-0.02,0.22c-0.4,4.68-2.27,8.96-5.13,12.38 l-0.15,0.18c-0.77,0.92-1.62,1.76-2.54,2.54c-0.06,0.05-0.11,0.09-0.17,0.14c-3.42,2.87-7.69,4.73-12.38,5.14 c-0.07,0.01-0.15,0.01-0.22,0.02c-0.6,0.05-1.2,0.08-1.81,0.08c-0.6,0-1.21-0.03-1.8-0.08c-0.07-0.01-0.15-0.01-0.22-0.02 c-4.67-0.41-8.95-2.27-12.37-5.15c-0.06-0.04-0.12-0.09-0.18-0.14c-0.92-0.77-1.78-1.62-2.54-2.54 c-0.05-0.06-0.1-0.12-0.14-0.18c-2.88-3.41-4.74-7.69-5.14-12.37c-0.01-0.07-0.01-0.15-0.02-0.22c-0.06-0.6-0.09-1.2-0.09-1.8 c0-0.6,0.03-1.2,0.09-1.8c0.01-0.07,0.01-0.15,0.02-0.22c0.4-4.68,2.26-8.96,5.14-12.37c0.04-0.06,0.09-0.12,0.14-0.18 c0.76-0.92,1.62-1.77,2.54-2.54c0.06-0.05,0.12-0.1,0.18-0.14c3.42-2.88,7.7-4.74,12.37-5.15c0.07-0.01,0.15-0.01,0.22-0.02 c0.59-0.05,1.2-0.08,1.8-0.08c0.61,0,1.21,0.03,1.81,0.08c0.07,0.01,0.15,0.01,0.22,0.02c4.69,0.41,8.96,2.27,12.38,5.14 c0.06,0.05,0.11,0.09,0.17,0.14c0.92,0.78,1.77,1.62,2.54,2.54l0.15,0.18c2.86,3.42,4.73,7.7,5.13,12.38 c0.01,0.07,0.01,0.15,0.02,0.22C257.48,95.9,257.5,96.5,257.5,97.1z"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M244.63,112.08l-7.59-12.81c-0.4-0.68-1.29-0.88-1.94-0.43l0,0c-0.65,0.45-0.78,1.35-0.29,1.97l9.26,11.66 C244.33,112.8,244.84,112.44,244.63,112.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: -241.8675,
    y1: 2493.4895,
    x2: -237.7986,
    y2: 2493.4895,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -998.6915 -2104.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    style: {
      stopColor: "#A5CBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6815,
    style: {
      stopColor: "#8CB4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M237.03,74.7v0.67c0,1.12-0.91,2.03-2.03,2.03c-1.11,0-2.02-0.91-2.02-2.03V74.7 c0.07-0.01,0.15-0.01,0.22-0.02c0.59-0.05,1.2-0.08,1.8-0.08c0.61,0,1.21,0.03,1.81,0.08 C236.88,74.69,236.96,74.69,237.03,74.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: -242.6069,
    y1: 2536.4021,
    x2: -238.5385,
    y2: 2536.4021,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1022.8964 -2097.1082)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    style: {
      stopColor: "#A5CBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6815,
    style: {
      stopColor: "#8CB4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M237.03,118.83v0.67c-0.07,0.01-0.15,0.01-0.22,0.02c-0.6,0.05-1.2,0.08-1.81,0.08 c-0.6,0-1.21-0.03-1.8-0.08c-0.07-0.01-0.15-0.01-0.22-0.02v-0.67c0-1.12,0.91-2.03,2.02-2.03 C236.12,116.8,237.03,117.71,237.03,118.83z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: -220.6143,
    y1: 2515.313,
    x2: -216.8848,
    y2: 2515.313,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1006.978 -2088.822)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    style: {
      stopColor: "#A5CBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6815,
    style: {
      stopColor: "#8CB4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M257.5,97.1c0,0.6-0.02,1.2-0.08,1.8c-0.01,0.07-0.01,0.15-0.02,0.22h-0.67c-1.12,0-2.02-0.9-2.02-2.02 c0-1.12,0.9-2.02,2.02-2.02h0.67c0.01,0.07,0.01,0.15,0.02,0.22C257.48,95.9,257.5,96.5,257.5,97.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: -263.5219,
    y1: 2514.5813,
    x2: -259.7946,
    y2: 2514.5813,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1014.6108 -2113.0295)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    style: {
      stopColor: "#A5CBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6815,
    style: {
      stopColor: "#8CB4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M215.3,97.1c0,1.12-0.91,2.02-2.02,2.02h-0.67c-0.01-0.07-0.01-0.15-0.02-0.22 c-0.06-0.6-0.09-1.2-0.09-1.8c0-0.6,0.03-1.2,0.09-1.8c0.01-0.07,0.01-0.15,0.02-0.22h0.67 C214.39,95.08,215.3,95.98,215.3,97.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: -226.9073,
    y1: 2529.821,
    x2: -222.7779,
    y2: 2529.821,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1016.8013 -2089.3796)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    style: {
      stopColor: "#A5CBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6815,
    style: {
      stopColor: "#8CB4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M252.27,111.5l-0.15,0.18c-0.77,0.92-1.62,1.76-2.54,2.54c-0.06,0.05-0.11,0.09-0.17,0.14l-0.47-0.47 c-0.79-0.79-0.79-2.07,0-2.86s2.07-0.79,2.86,0L252.27,111.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: -257.6216,
    y1: 2500.0764,
    x2: -253.4946,
    y2: 2500.0764,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1004.7886 -2112.4651)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    style: {
      stopColor: "#A5CBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6815,
    style: {
      stopColor: "#8CB4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M221.07,83.17c-0.79,0.79-2.07,0.79-2.86,0l-0.46-0.46c0.04-0.06,0.09-0.12,0.14-0.18 c0.76-0.92,1.62-1.77,2.54-2.54c0.06-0.05,0.12-0.1,0.18-0.14l0.46,0.46C221.86,81.1,221.86,82.38,221.07,83.17z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: -226.8407,
    y1: 2499.5911,
    x2: -223.8125,
    y2: 2499.5911,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -999.251 -2094.9133)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    style: {
      stopColor: "#A5CBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6815,
    style: {
      stopColor: "#8CB4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M252.27,82.7l-0.47,0.47c-0.79,0.79-2.07,0.79-2.86,0s-0.79-2.07,0-2.86l0.47-0.47 c0.06,0.05,0.11,0.09,0.17,0.14c0.92,0.78,1.77,1.62,2.54,2.54L252.27,82.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: -256.588,
    y1: 2530.2966,
    x2: -253.5733,
    y2: 2530.2966,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1022.3331 -2106.9333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    style: {
      stopColor: "#A5CBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6815,
    style: {
      stopColor: "#8CB4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M221.07,113.89l-0.46,0.46c-0.06-0.04-0.12-0.09-0.18-0.14c-0.92-0.77-1.78-1.62-2.54-2.54 c-0.05-0.06-0.1-0.12-0.14-0.18l0.46-0.46c0.79-0.79,2.07-0.79,2.86,0C221.86,111.82,221.86,113.1,221.07,113.89z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.83,
    y1: 991.7401,
    x2: 238.163,
    y2: 991.7401,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    style: {
      stopColor: "#A5CBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6815,
    style: {
      stopColor: "#8CB4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M231.83,97.74c0-1.75,1.42-3.17,3.17-3.17s3.17,1.42,3.17,3.17s-1.42,3.17-3.17,3.17 C233.25,100.91,231.83,99.49,231.83,97.74z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.6992,
    y1: 996.398,
    x2: 245.9681,
    y2: 996.398,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    style: {
      stopColor: "#A5CBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6815,
    style: {
      stopColor: "#8CB4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M245.88,107.96l-9.79-11.23c-0.52-0.59-1.43-0.62-1.99-0.07l0,0c-0.56,0.56-0.53,1.47,0.07,1.99l11.23,9.79 C245.71,108.72,246.16,108.28,245.88,107.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: -245.1859,
    y1: 2510.2239,
    x2: -235.8554,
    y2: 2510.2239,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1008.0112 -2101.8015)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    style: {
      stopColor: "#A5CBBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6815,
    style: {
      stopColor: "#8CB4BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M234.5,85.48l-1.48,11.72c-0.15,1.19,0.78,2.25,1.98,2.25l0,0c1.2,0,2.13-1.05,1.98-2.25l-1.48-11.72 C235.42,84.9,234.58,84.9,234.5,85.48z"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M370.49,114.47l-0.45-0.14c-0.09-0.39-0.25-0.77-0.45-1.11l0.22-0.41c0.11-0.21,0.07-0.46-0.09-0.62 l-0.47-0.47c-0.16-0.16-0.41-0.2-0.62-0.09l-0.4,0.21c-0.34-0.21-0.72-0.37-1.13-0.47l-0.13-0.42c-0.07-0.22-0.27-0.37-0.5-0.37 h-0.67c-0.23,0-0.43,0.15-0.5,0.37l-0.13,0.42c-0.4,0.1-0.78,0.26-1.13,0.47l-0.4-0.21c-0.2-0.11-0.45-0.07-0.62,0.09l-0.47,0.47 c-0.16,0.16-0.2,0.41-0.09,0.62l0.22,0.41c-0.2,0.34-0.36,0.71-0.45,1.11l-0.45,0.14c-0.22,0.07-0.37,0.27-0.37,0.5v0.67 c0,0.23,0.15,0.43,0.37,0.5l0.47,0.14c0.1,0.38,0.25,0.74,0.45,1.07l-0.23,0.44c-0.11,0.2-0.07,0.45,0.09,0.62l0.47,0.47 c0.16,0.16,0.41,0.2,0.62,0.09l0.45-0.24c0.32,0.19,0.68,0.34,1.05,0.43l0.15,0.49c0.07,0.22,0.27,0.37,0.5,0.37h0.67 c0.23,0,0.43-0.15,0.5-0.37l0.15-0.49c0.37-0.1,0.73-0.24,1.05-0.43l0.45,0.24c0.2,0.11,0.45,0.07,0.62-0.09l0.47-0.47 c0.16-0.16,0.2-0.41,0.09-0.62l-0.23-0.44c0.2-0.33,0.35-0.69,0.45-1.07l0.47-0.14c0.22-0.07,0.37-0.27,0.37-0.5v-0.67 C370.86,114.74,370.71,114.54,370.49,114.47z M366.13,117.49c-1.22,0-2.22-0.99-2.22-2.22c0-1.22,0.99-2.22,2.22-2.22 c1.22,0,2.22,0.99,2.22,2.22S367.36,117.49,366.13,117.49z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: -110.8617,
    y1: 2496.5569,
    x2: -88.1996,
    y2: 2496.5569,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -938.8945 -2012.2382)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M422.04,88.02l-1.08-0.33c-0.23-0.95-0.6-1.84-1.08-2.66l0.52-0.98c0.26-0.49,0.17-1.09-0.22-1.48 l-1.13-1.13c-0.39-0.39-0.99-0.48-1.48-0.22l-0.95,0.5c-0.83-0.51-1.74-0.89-2.7-1.13l-0.31-1.02c-0.16-0.53-0.65-0.89-1.2-0.89 h-1.6c-0.55,0-1.04,0.36-1.2,0.89l-0.31,1.02c-0.97,0.24-1.88,0.62-2.7,1.13l-0.95-0.5c-0.49-0.26-1.09-0.17-1.48,0.22L403,82.57 c-0.39,0.39-0.48,0.99-0.22,1.48l0.52,0.98c-0.48,0.82-0.85,1.71-1.08,2.66l-1.08,0.33c-0.53,0.16-0.89,0.65-0.89,1.2v1.6 c0,0.55,0.36,1.04,0.89,1.2l1.12,0.35c0.24,0.91,0.6,1.77,1.08,2.56L402.78,96c-0.26,0.49-0.17,1.09,0.22,1.48l1.13,1.13 c0.39,0.39,0.99,0.48,1.48,0.22l1.09-0.57c0.78,0.46,1.62,0.81,2.52,1.03l0.37,1.19c0.16,0.53,0.65,0.89,1.2,0.89h1.6 c0.55,0,1.04-0.36,1.2-0.89l0.37-1.19c0.9-0.23,1.74-0.58,2.51-1.03l1.09,0.57c0.49,0.26,1.09,0.17,1.48-0.22l1.13-1.13 c0.39-0.39,0.48-0.99,0.22-1.48l-0.56-1.06c0.48-0.79,0.84-1.65,1.08-2.56l1.12-0.35c0.53-0.16,0.89-0.65,0.89-1.2v-1.6 C422.93,88.67,422.57,88.18,422.04,88.02z M411.59,95.26c-2.93,0-5.31-2.38-5.31-5.31s2.38-5.31,5.31-5.31s5.31,2.38,5.31,5.31 C416.9,92.88,414.52,95.26,411.59,95.26z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M373.06,135.82h-3.63c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h3.63c0.2,0,0.36,0.16,0.36,0.36 C373.42,135.66,373.26,135.82,373.06,135.82z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M367.85,135.82h-8.64c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h8.64c0.2,0,0.36,0.16,0.36,0.36 C368.2,135.66,368.04,135.82,367.85,135.82z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M373.06,129.46h-3.63c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h3.63c0.2,0,0.36,0.16,0.36,0.36 C373.42,129.31,373.26,129.46,373.06,129.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M367.85,129.46h-8.64c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h8.64c0.2,0,0.36,0.16,0.36,0.36 C368.2,129.31,368.04,129.46,367.85,129.46z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M362.83,132.86h-3.63c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h3.63c0.2,0,0.36,0.16,0.36,0.36 C363.18,132.7,363.02,132.86,362.83,132.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M373.06,132.86h-8.64c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h8.64c0.2,0,0.36,0.16,0.36,0.36 C373.42,132.7,373.26,132.86,373.06,132.86z"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M373.06,149.82h-3.63c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h3.63c0.2,0,0.36,0.16,0.36,0.36 C373.42,149.66,373.26,149.82,373.06,149.82z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M367.85,149.82h-8.64c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h8.64c0.2,0,0.36,0.16,0.36,0.36 C368.2,149.66,368.04,149.82,367.85,149.82z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M373.06,143.46h-3.63c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h3.63c0.2,0,0.36,0.16,0.36,0.36 C373.42,143.31,373.26,143.46,373.06,143.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M367.85,143.46h-8.64c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h8.64c0.2,0,0.36,0.16,0.36,0.36 C368.2,143.31,368.04,143.46,367.85,143.46z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M362.83,146.86h-3.63c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h3.63c0.2,0,0.36,0.16,0.36,0.36 C363.18,146.7,363.02,146.86,362.83,146.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M373.06,146.86h-8.64c-0.2,0-0.36-0.16-0.36-0.36s0.16-0.36,0.36-0.36h8.64c0.2,0,0.36,0.16,0.36,0.36 C373.42,146.7,373.26,146.86,373.06,146.86z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.9652,
    y1: 1158.3096,
    x2: 205.9556,
    y2: 1158.3096,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FD8FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDB592"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M220.39,262.49c0.42,0.49,0.61,0.93,0.57,1.19c-0.03,0.26-0.1,1.09-2.14,1.92c-2.71,1.1-4.37,0.83-7.5,0.86 c-2.95,0.03-4.32-0.06-4.98-0.97c-0.66-0.91-0.27-3.34-0.27-3.34l6.29,0.66L220.39,262.49z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 205.23,
    y1: 1155.8075,
    x2: 220.5887,
    y2: 1155.8075,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FD8FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDB592"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M209.32,258.6c1.52,1.07,3.25,1.53,5.04,2.18c1.09,0.4,3.69,0.71,4.79,1.02c1.1,0.31,1.64,0.95,1.37,1.33 c-0.27,0.38-2.09,1.42-3.78,1.66c-2.95,0.43-4.66,0.12-7.31,0.07c-2.52-0.05-3.3-0.72-3.44-1.64s-0.76-3.52-0.76-3.52 L209.32,258.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 200.5291,
    y1: 1155.9746,
    x2: 185.5888,
    y2: 1155.9746,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FD8FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDB592"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M200.11,261.57c0.35,0.55,0.47,1.01,0.4,1.26c-0.07,0.26-0.25,1.06-2.39,1.6c-2.83,0.71-4.35,0.07-7.85-1.02 c-2.82-0.88-3.96,0.15-4.49-0.85c-0.53-0.99,0.21-3.34,0.21-3.34l6.13,1.54L200.11,261.57z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.51,
    y1: 1153.7451,
    x2: 200.2525,
    y2: 1153.7451,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FD8FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDB592"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M189.7,256.16c1.35,1.27,3,1.97,4.68,2.87c1.02,0.55,3.55,1.22,4.6,1.68s1.49,1.17,1.17,1.51 s-2.27,1.11-3.97,1.11c-2.98,0.01-3.7-0.93-6.32-1.36c-2.49-0.4-4.09-0.79-4.1-1.72c-0.01-0.94-0.25-3.59-0.25-3.59L189.7,256.16z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: -114.3887,
    y1: 2672.0164,
    x2: -70.5944,
    y2: 2672.0164,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1264.9053 -2014.0061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3A2D97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2875C6"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M190.71,201.18c0.05,7.86-1.06,24.65-0.67,30.6c-3.03,7.5-5.76,17.84-4.72,24.83 c0.79,1.13,3.26,1.37,4.71,0.41c1.08-4.25,5.53-22.31,5.99-24.83c0.99-4.7,8.4-22.52,5.2-29.23 C198.15,201.32,190.71,201.18,190.71,201.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.0947,
    y1: 1123.3988,
    x2: 202.0165,
    y2: 1123.3988,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6D3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CABB7"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M190.71,201.18c0.05,7.86-1.06,24.65-0.67,30.6c-3.03,7.5-5.76,17.84-4.72,24.83 c0.79,1.13,3.26,1.37,4.71,0.41c1.08-4.25,5.53-22.31,5.99-24.83c0.99-4.7,8.4-22.52,5.2-29.23 C198.15,201.32,190.71,201.18,190.71,201.18z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: -100.1672,
    y1: 2672.28,
    x2: -65.3166,
    y2: 2672.28,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1262.7734 -2011.2659)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6D3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CABB7"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M208.64,233.9c0.73,6.76,1.4,21.35,1.48,25.2c-0.37,0.32-3.45,1.41-4.83,0.93 c-0.96-7.58-4.99-17.97-2.95-24.46c-1.19-6.55-5.07-17.45-5.65-26.12c-8.74-4.1-8.66-7.79-8.85-13.3l10.76,0.02l3.43-1.56 C202.02,194.61,209.22,213.9,208.64,233.9z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M221.75,169.36c1.39-1.3,1.28-2.46,1.66-4.01c0.39-1.55,3.49-4.01,5.41-4.07c1.93-0.05,3.56,0.37,3.56,0.37 c-1.33,1.67-4.08,1.63-5.01,3.12c-0.93,1.49-1.4,2.21-1.79,2.73c1.21-0.44,1.61-1.61,2.48-2.27s1.58-1.48,2.22-0.84 c-0.65,0.61-1.69,1.69-2.07,2.24c-0.37,0.56-1.02,3.22-2.33,3.21c-1.31,0-2.26,0.37-2.99,1.12 C222.16,171.72,221.75,169.36,221.75,169.36z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: -86.108,
    y1: 2616.8442,
    x2: -61.5505,
    y2: 2616.8442,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1230.6401 -2015.0999)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FD8FA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDB592"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M199.56,165.27c2.72,1.34,9.58,9.09,11.32,12.8c2.15-3.56,8.65-8.05,10.48-9.42 c1.25-1.21,3.83,1.68,2.65,2.76c-1.23,1.87-11.33,10.4-13.23,12.2s-17.17-14.5-17.17-14.5L199.56,165.27z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M199.56,165.27c2.72,1.34,9.58,9.09,11.32,12.8c2.15-3.56,8.65-8.05,10.48-9.42 c1.25-1.21,3.83,1.68,2.65,2.76c-1.23,1.87-11.33,10.4-13.23,12.2s-17.17-14.5-17.17-14.5L199.56,165.27z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: -61.4932,
    y1: 2613.3442,
    x2: -44.7631,
    y2: 2613.3442,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1223.0267 -2002.6809)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3A2D97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2875C6"
    }
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M226.54,174.69l-0.12-0.12c-0.38-0.38-0.38-0.98,0-1.36l10.61-10.61c0.38-0.38,0.98-0.38,1.36,0l0.12,0.12 c0.38,0.38,0.38,0.98,0,1.36l-10.61,10.61C227.52,175.07,226.91,175.07,226.54,174.69z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M186.12,171.41c0.09,0.47,0.19,0.97,0.32,1.49c1.88,7.71-1.77,10.02,0.83,21.96 c0.12,0.54,0.24,1.1,0.36,1.68c1.03,4.98,14.86,0.7,14.82-1.18c-0.1-5.17,2.07-15.21,1.75-21.06c-0.03-0.57-0.06-1.16-0.07-1.77 c-0.02-0.76-0.21-1.51-0.56-2.19c-1.76-3.35-6.11-8.62-6.11-8.62l-8.5-1.2C187.79,163.32,184.89,164.67,186.12,171.41z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M187.22,168c1.1,5.2,5.14,16.84,15.86,19.65c0.37-2.94,0.2-5.65,0.42-8.72c-1.23-1.46-2.85-6.61-5.54-9.39 c-2.82-2.91-3.67-4.26-3.67-4.26L187.22,168z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M189.85,159.61l0.17,0.02l3.6,0.39l1.46,0.16l0.29-2.75c1.67,1.85,4.23,3.55,6.62-0.08 c1.78-2.64,2.88-4.59,3.59-7.6c0.19-0.79,0.35-1.66,0.49-2.62l-14.9-2.74l-1.31,15.17L189.85,159.61z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M189.86,159.55l0.16,0.08l3.46,1.64c-0.05-0.43,0.02-0.84,0.15-1.25c0.44-1.44-0.02-1.92-0.14-3.45 c-0.03-0.35,0.49-2.12,0.58-2.46c0.22-0.83,2.39-0.44,3.02-1.01c1.21-1.1,0.41-3.31,1.42-4.6c0.45-0.59,1.21-0.87,1.96-0.92 c0.74-0.04,1.48,0.13,2.2,0.29l2.92,1.88c0.19-0.79,0.35-1.66,0.49-2.62l-14.9-2.74L189.86,159.55z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: -97.3101,
    y1: 2590.2529,
    x2: -80.0894,
    y2: 2590.2529,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1216.0049 -2026.2996)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3726,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5069,
    style: {
      stopColor: "#090807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6026,
    style: {
      stopColor: "#141311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#25221F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7463,
    style: {
      stopColor: "#3B3730"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    style: {
      stopColor: "#574F47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    style: {
      stopColor: "#776D61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9069,
    style: {
      stopColor: "#9D9080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9523,
    style: {
      stopColor: "#C8B7A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9926,
    style: {
      stopColor: "#F6E2C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEAD0"
    }
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M190.48,152.07c2.68-0.04,1.08-3.54,3.15-3.54s1.14,2.71,2.73,1.46c2.15-1.49,2.3-3.45,5.38-2.39 c3.08,1.05,2.09-0.69,3.85,2.16c1.63-2.42,1.78-3.97,0.49-5.37c-1.4-1.53-1.48-2.5-3.63-3.34c-1.75-0.69-1.59-2.89-5.13-0.89 c-1.22-1.35-4.92-0.58-5.06,1.23C189.27,142.28,190.14,147.26,190.48,152.07z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M226.15,175.17c0.76-0.09,4.48-0.21,5.89-1.49c1.4-1.28,4.14-5.37,5.13-5.88c-0.98-1.22-3.22,0.12-3.97,1.34 s-3.13,3.1-4.24,3.19c-0.24-1.28,0.27-1.64,1.07-2.06c0.78-0.42,0.96-2,0.57-2.42c-0.2-0.15-1.01,1.01-1.58,1.19 c-0.57,0.18-1.58,1.01-1.67,1.64s-0.83,2.43-1.34,2.47c-0.52,0.04-2,0.81-2,0.81L226.15,175.17z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M187.27,167.63c0.02,0.94,0.41,1.94,1.24,2.9c3.97,4.54,8.71,13.87,19.1,15.21 c9.48-2.32,17.59-7.34,18.67-9.48c-0.03-0.45-0.08-0.85-0.14-1.21c-0.44-2.46-1.53-2.76-2.55-3c-3.84,2.33-11,5.01-15.57,7.43 c-7.63-5.12-8.93-6.83-14.14-15.53C191.97,160.77,187.17,164.69,187.27,167.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: -96.0077,
    y1: 2606.449,
    x2: -87.951,
    y2: 2606.449,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1225.8016 -2025.871)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6D3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CABB7"
    }
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M197.07,160.48l3.05,3.46c0.05,0.06,0,0.16-0.08,0.14l-11.59-2.76l1.11-2.5l6.14,0.92 C196.23,159.82,196.71,160.08,197.07,160.48z"
  }))), /*#__PURE__*/React.createElement("g", null, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M305.14,279.99c0.24,0.56,1.04,1.51-0.31,2.18c-1.34,0.67-4.97,0.04-6.44-1.14 c-1.47-1.18-2.07-2.14-2.45-2.17c-0.37-0.03-2.63-0.35-3.04-0.81c-0.41-0.47-0.74-2.06-0.74-2.06l5.83,2.14L305.14,279.99z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M292.33,274.48c-0.28,0.61-0.36,2.54,0.82,2.87c2.08,0.59,3.62,1.4,3.78,1.47c0.2,0.1,1.14,1.22,1.36,1.33 c1.39,0.69,1.93,0.97,3.25,1.41c0.79,0.26,1.89,0.33,2.7,0.1c0.65-0.19,1.3-0.5,1.15-1.11c-0.18-0.72-0.98-1.64-1.87-2.18 c-0.91-0.55-1.64-1.17-2.76-1.89c-1-0.64-2.02-1.19-2.58-1.59c-0.61-0.44-1.27-1.06-1.75-1.29c-0.97-0.46-1.61-1.16-2.04,0.19 c-0.24,0.77,0.36,0.31-0.13,1.01C293.97,275.2,293.04,272.95,292.33,274.48z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M296.16,273.91c-0.05,0.3-0.23,0.56-0.48,0.75c-1.06,0.88-3.5,0.8-3.78-0.89 c-0.34-2.09-4.47-18.55-2.31-26.58c-2.39-8.04-8.09-29.38-8.1-33.43c-0.01-3.55,7.66-1.33,9.57-0.72 c0.27,0.09,0.42,0.14,0.42,0.14c1.59,9.19,2.92,25.95,3.73,32.05C297.06,251.11,296.71,268.91,296.16,273.91z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M296.16,273.91c-0.05,0.3-0.23,0.56-0.48,0.75c-0.91-7.83,0.29-19.9-1.24-28.54 c-0.23-4.08-2.39-8.15-2.95-12.2c-0.51-3.57,0.7-7.43-0.07-10.96c-0.51-2.38,0.01-7.66-1.67-9.25c-0.82-0.77-0.07-1.4,0.93-1.47 c0.27,0.09,0.64-0.56,0.64-0.56c1.59,9.19,3.09,27.46,3.9,33.56C297.06,251.11,296.71,268.91,296.16,273.91z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M264.85,284.08c0.03,0.59-0.26,1.74,1.18,1.76c1.44,0.02,4.31-2.04,5.09-3.68c0.78-1.64,0.9-2.72,1.21-2.9 s2.13-1.4,2.29-1.97c0.16-0.58-0.23-2.09-0.23-2.09l-4.15,4.29L264.85,284.08z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M271.13,211.97c0,0-0.46,0.38-1.41,0.33c-0.58,1.06-1.57,2.35-2.01,2.51c0.51,0.41,1.08,0.27,1.44-0.25 c0.36-0.52,0.8-1.27,0.94-1.12c0.04,0.43-0.59,2.22-1.65,2.5s0.4,0.61,0.4,0.61s2.07-0.35,2.12-0.49s1.1-2.04,1.11-2.35 c0.01-0.31-0.42-1.6-0.42-1.6L271.13,211.97z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M267.58,214.39c-0.19-0.67-0.16-1.36-0.8-1.37c0.24,0.8,0.53,2.72,0.6,3.21c0.48,0.19,0.53-0.36,0.53-0.41 S267.58,214.39,267.58,214.39z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M271.13,211.97c0,0-0.46,0.38-1.41,0.33c-0.58,1.06-1.57,2.35-2.01,2.51c0.51,0.41,1.08,0.27,1.44-0.25 c0.36-0.52,0.8-1.27,0.94-1.12c0.04,0.43-0.59,2.22-1.65,2.5s0.4,0.61,0.4,0.61s2.07-0.35,2.12-0.49s1.1-2.04,1.11-2.35 c0.01-0.31-0.42-1.6-0.42-1.6L271.13,211.97z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M267.58,214.39c-0.19-0.67-0.16-1.36-0.8-1.37c0.24,0.8,0.53,2.72,0.6,3.21c0.48,0.19,0.53-0.36,0.53-0.41 S267.58,214.39,267.58,214.39z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M272.49,210.04L272.49,210.04c-2.51-4.95-6.34-11.62-7.97-12.93c3.19-3.62,4.09-8.53,4.09-8.53l-5.81,1.44 c-2.06,1.94-2.88,5.81-2.94,6.62c1.78,4.46,1.84,8.63,9.89,14.38l1.27,1.4c0,0-0.15,3.61-2.49,3.34 c-0.43-1.18-0.15-2.74-1.26-3.13c0.15,0.73,0.37,3.4-0.08,4.28c1.28,0.23,3.01,0.75,4.01-0.41c1.01-1.15,1.82-2.32,2.46-3.91 C274,211.76,273.26,210.78,272.49,210.04z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M273.63,273.95c0.5,0.41,1.37,2.04,0.49,2.83c-1.55,1.38-2.55,2.73-2.65,2.86c-0.13,0.17-0.48,1.53-0.62,1.72 c-0.92,1.18-1.26,1.65-2.22,2.58c-0.58,0.56-1.5,1.08-2.29,1.21c-0.64,0.11-1.34,0.11-1.46-0.48c-0.14-0.7,0.16-1.83,0.7-2.67 c0.55-0.86,0.93-1.7,1.6-2.79c0.59-0.98,1.25-1.88,1.57-2.46c0.34-0.63,0.66-1.45,0.97-1.84c0.64-0.81,0.9-1.68,1.84-0.69 c0.53,0.56-0.18,0.42,0.54,0.82C272.51,275.26,272.37,272.92,273.63,273.95z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M268.82,178.62c-4.46,5.27-6.46,10.84-7.02,11.84s4.44,4.69,5.94,2.62s4.94-7.07,4.94-7.07L268.82,178.62z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M282.64,223.38c-0.7,7.47-2.35,16.72-4.93,23.41c2.17,7.16-2.52,22.19-2.52,25.99c0,0.57-0.14,1.08-0.39,1.53 c-1.37,2.55-5.92,2.96-5.42-1c0.66-5.13,0.34-16.03,2.05-26.47c-0.14-9.62,0.3-25.52,2.31-36.09c0,0,1.9-0.9,3.97-1.25 c0.03-0.01,0.06-0.02,0.09-0.02c2.09-0.34,4.33-0.12,4.9,2.18C283.17,213.57,283.16,218.01,282.64,223.38z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M288.58,173.72c-0.38,0.04-0.81-0.05-1.24-0.21c-0.6-0.23-1.22-0.6-1.71-0.93c0,0-0.25,1.53-0.65,5.24 c-0.08,0.73-6.1,1.15-6.1,1.15l-1.03-5.07c0,0,1.33-1.5,1.51-3.28c0.1-0.91,0.14-1.84,0.05-2.54c-0.28-2.03-0.25-4.6,2.26-7.29 c2.19-2.36,7.68-1.55,9.47-1.25c0.26,0.04,0.44,0.07,0.52,0.08c0.4,0.04,0.85-0.06,1.19,0.18v0.01c0.24,0.16,0.43,0.49,0.49,1.15 C293.34,160.95,292.45,173.34,288.58,173.72z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M277.71,246.79c2.17,7.16-2.52,22.19-2.52,25.99c0,0.57-0.14,1.08-0.39,1.53c-0.94-1.86-0.26-2.75-0.3-4.91 c2.37-6.79,3.24-14.87,1.89-22.97c2.52-12.55,4.04-14.16,6.42-25.04C282.12,228.85,281.79,236.3,277.71,246.79z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M289.49,162.02c-0.72,0.07-1.48,0.18-2.01,0.66c-0.73,0.65-0.79,1.75-0.83,2.74 c-0.05,0.98-0.22,2.1-1.05,2.63c-0.9,0.57-2.12,0.14-3.11,0.55c-0.94,0.4-1.45,1.49-2.39,1.89c-0.23,0.1-0.48,0.14-0.73,0.13 c0.1-0.91,0.14-1.84,0.05-2.54c-0.28-2.03-0.25-4.6,2.26-7.29c2.19-2.36,7.68-1.55,9.47-1.25c0.16,0.29,0.36,0.56,0.6,0.8 C292.86,161.37,290.17,161.94,289.49,162.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 228.0254,
    y1: 2743.5132,
    x2: 245.6814,
    y2: 2743.5132,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1482.7764 -1951.0511)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E9E7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9D9593"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M293.23,161.45c2.13-2.88,0.19-5.11-2.75-5.3c-1.05-2.6-3.6-3.19-5.58-1.89c-1.04-0.02-2.61,1.6-3.5,3.52 c-2.61,0.42-3.54,0.71-3.42,3.93c-0.16,2.32,0.68,4.23,1.43,6.37c1.8-1.48,0.21-3.55,1.25-4.39c0.92-0.74,2.01,0.4,2.28,1.55 c0.26,0.18,1.6,0.25,1.6,0.25l0.1-4.63C287.24,159.31,291.55,160.01,293.23,161.45z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M285.64,172.58c-1.77-1.4-3.39-3.03-3.77-3.65c-0.06,1.39,1,3.46,3.39,4.51 C285.31,173.19,285.64,172.58,285.64,172.58z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M294.74,180.21c0.17-1.5,0.25-2.4,0.25-2.4s-6.95-2.8-9.6-3.55c-1.78,3.98-3.9,3.34-7.55-0.38 c-1.64,0.78-6.43,2.82-9.02,4.74c-1.5,3.22,5.48,18,5.48,16.92c0.19,3.51-0.2,10.57-0.87,16.12c-0.1,0.83,0.21,1.5,0.81,2.05 c1.78,1.61,6.11,2.04,9.99,1.64c4.25-0.33,8.08-1.53,7.83-3.24c-0.17-1.13-0.03-2.9,0.15-5.16c0.17-1.77,0.31-3.85,0.34-6.11 h-0.01c0.02-1.04,0.01-2.13-0.03-3.26h0.01c-0.01-0.18-0.03-0.38-0.04-0.56c-0.03-0.6-0.06-1.2-0.11-1.82 c0.72-3.41,1.3-6.94,1.72-9.93c0.03-0.19,0.06-0.39,0.09-0.58c0.07-0.49,0.13-0.96,0.19-1.41 C294.51,182.11,294.64,181.07,294.74,180.21L294.74,180.21z M290.29,198.46c-0.08,0.48-0.11,1-0.13,1.51 C289.7,199.41,289.52,198.75,290.29,198.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.3998,
    y1: 1094.3439,
    x2: 293.1097,
    y2: 1092.4465,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005AB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#28AAFF"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M292.54,200.85c-0.3,0.04-0.58,0.06-0.83,0.08h-0.06c-0.89-0.01-2.83-1.93-1.35-2.47 c0.8-0.29,1.53-0.58,2.21-0.87C292.55,198.71,292.56,199.8,292.54,200.85z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M292.36,195.21c0.65,7.99-0.71,14.25-0.31,16.91c0.5,3.3-14.36,4.72-17.81,1.6c1.78-0.94,4.47,0.45,6.5,0.2 c2.32-0.28,5.98-0.41,7.42-2.24c0.91-1.15,1.77-4.29,1.9-5.76c0.13-1.46-0.21-3.01,0-4.46c0.17-1.11,0.02-2.53,0.35-3.6 c0.4-1.35-0.65-2.62-0.24-3.96c0.95-3.16,1.9-6.32,2.86-9.48c0.3-1,0.52-3.17,1.27-3.91c0.16-0.16,0.31-0.25,0.44-0.29 C294.36,183.46,293.57,189.52,292.36,195.21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.7489,
    y1: 2775.4583,
    x2: 260.45,
    y2: 2775.4583,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1497.8501 -1936.7693)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C27F6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCFBA"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M310.59,193.25c-2.74,5.37-14.72,7.35-18.88,7.68h-0.06c0.21-0.34,0.46-0.65,0.7-0.89 c1.11-1.11,2.6-1.42,4.09-1.74c4.06-0.88,7.98-2.37,11.6-4.4c0.65-0.36,1.35-0.82,1.52-1.54c0.23-0.93-0.51-1.81-1.25-2.41 c-1.31-1.08-2.81-1.9-4.18-2.91c-1.36-1-2.63-2.24-3.24-3.82c0.24-0.17,0.5-0.3,0.78-0.38 C306.53,186.78,311.33,191.38,310.59,193.25z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M301.67,182.84c-2.45-1.99-4.91-3.81-6.68-5.02c0,0-0.08,0.9-0.25,2.4c-0.14,1.18-0.33,2.72-0.57,4.48 c2.65,2.12,7.29,5.68,10.78,7.63c-4.61,0.27-6.38,2.69-12.44,5.26c-0.68,0.29-1.41,0.58-2.21,0.87c-0.1,0.04-0.18,0.08-0.25,0.12 l0,0c-1.15,0.58-2.02,1-2.9,1.25c-0.17,1.12-1,2.58-1.42,3.12c0.75,0.42,1.88-1.12,1.88-1.79c0.16-0.51,0.48-0.35,0.78-0.51 c-0.2,0.37-1.28,3.09-1.2,3.55c0.08,0.45-0.27,2.58,0.7,3.61c1.36-0.33,2.05-0.9,2.53-2.08c0.18-0.44,0.14-1.56-0.16-2.53 c0.45-0.14,1.43-1.36,1.76-2.31c0.17-0.02,0.33-0.03,0.51-0.05c4.73-0.5,15.47-2.55,18.05-7.6 C311.33,191.39,306.53,186.78,301.67,182.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.3519,
    y1: 2783.4448,
    x2: 247.504,
    y2: 2783.4448,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1503.5848 -1938.9187)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#293340"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M295.43,198.85c0.26,0.43,0.52,1.48,0.54,1.72c0.02,0.25-1.7,0.51-1.73,0.32c-0.03-0.19-0.21-1.41-0.42-1.61 C293.61,199.08,295.43,198.85,295.43,198.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.8495,
    y1: 1092.0801,
    x2: 291.9061,
    y2: 1092.0801,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#293340"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M295.51,199.1l-1.68,0.64c-0.32,0.12-0.73-0.02-0.91-0.33l-0.93-1.58c-0.18-0.3-0.06-0.65,0.26-0.77 l1.68-0.64c0.32-0.12,0.73,0.02,0.91,0.33l0.93,1.58C295.94,198.63,295.83,198.98,295.51,199.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.9061,
    y1: 1091.8601,
    x2: 295.8495,
    y2: 1091.8601,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#293340"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M295.51,198.88l-1.68,0.64c-0.32,0.12-0.73-0.02-0.91-0.33l-0.93-1.58c-0.18-0.3-0.06-0.65,0.26-0.77 l1.68-0.64c0.32-0.12,0.73,0.02,0.91,0.33l0.93,1.58C295.94,198.41,295.83,198.75,295.51,198.88z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M299.62,189.37c-1.11-0.68-3.53-2.02-5.67-3.18c0.35-2.38,0.61-4.47,0.79-5.97c0.17-1.5,0.25-2.4,0.25-2.4 c2.88,1.51,7.19,4.76,8.19,5.64C304.18,184.33,301.8,190.72,299.62,189.37z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.3391,
    y1: 2799.2949,
    x2: 377.3023,
    y2: 2799.2949,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1478.6514 -1915.429)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3726,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5069,
    style: {
      stopColor: "#090807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6026,
    style: {
      stopColor: "#141311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#25221F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7463,
    style: {
      stopColor: "#3B3730"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    style: {
      stopColor: "#574F47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    style: {
      stopColor: "#776D61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9069,
    style: {
      stopColor: "#9D9080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9523,
    style: {
      stopColor: "#C8B7A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9926,
    style: {
      stopColor: "#F6E2C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEAD0"
    }
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st64",
    d: "M424.61,169.02c2.6,4.42,0.41,8.52,1.35,10.88c1.93-0.05,5.02-3.79,6.56-4.95c0.67-0.51,1.2-1.19,1.65-1.91 c1.75-2.76,2.49-6.13,2.08-9.37c-0.27-2.12-1.09-4.25-2.7-5.65c-1.01-0.88-2.26-1.41-3.5-1.94c-0.47-0.2-1.7-1.01-2.19-0.71 c-0.42,0.26-1.27,0.46-1.44,0.9c-0.28,0.74,0.15,2.42-0.23,3.11C425.87,159.98,423.32,166.82,424.61,169.02z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.5744,
    y1: 2907.6152,
    x2: 362.2549,
    y2: 2907.6152,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1541.8486 -1904.3831)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6D3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CABB7"
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M420.16,270c-0.11,0.03-0.23,0.06-0.35,0.09c-2.9,0.74-8.14,0.96-10.25,4.02c-1.95,2.83,2.13,3.66,5.84,2.63 c1.85-0.52,2.96-1.25,3.99-1.46s1.98,0.12,2.93-0.1c1.21-0.29,1.22-2.09,0.87-4.39C422.84,268.49,420.16,270,420.16,270z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M422.47,271.03c-0.71,1.23-2.04,1.33-3.54,1.74c-1.05,0.29-2.13,0.93-3.37,1.37 c-3.11,1.1-3.88-1.75-1.55-2.63c1.11-0.42,5.46-1.23,6.22-2.48s2.45-0.18,2.45-0.18L422.47,271.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.8719,
    y1: 2908.9565,
    x2: 381.6305,
    y2: 2908.9565,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1539.1084 -1893.074)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6D3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CABB7"
    }
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M439.21,271.13c-0.11,0.04-0.22,0.09-0.34,0.13c-2.8,1.06-7.53,1.91-9.95,4.15 c-2.52,2.33,2.75,4.39,6.32,2.95s4.86-1.67,6.71-2.33c1.17-0.42,0.98-2.21,0.37-4.46C441.7,269.34,439.21,271.13,439.21,271.13z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M441.62,271.89c-0.96,2.21-3.63,2.46-6.52,3.86c-2.96,1.44-4.05-1.3-1.83-2.44c1.06-0.54,5.29-1.84,5.9-3.17 c0.62-1.33,2.42-0.45,2.42-0.45L441.62,271.89z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.0944,
    y1: 2871.5713,
    x2: 391.2635,
    y2: 2871.5713,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1520.5713 -1903.5027)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9447E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA86D1"
    }
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M426.61,209.67c-2.77,10.6-3.23,25.32-3.93,30.37c-0.51,4.66-3.59,26.97-3.71,29.49 c-0.25,1.9,4.29,2.57,4.67-0.55s8.13-15.75,5.22-27.62c3.66-8.34,9.88-27.61,8.5-30.73C435.97,207.51,426.61,209.67,426.61,209.67 z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M426.61,209.67c-2.77,10.6-3.23,25.32-3.93,30.37c-0.51,4.66-3.59,26.97-3.71,29.49 c-0.25,1.9,4.29,2.57,4.67-0.55s8.13-15.75,5.22-27.62c3.66-8.34,9.88-27.61,8.5-30.73C435.97,207.51,426.61,209.67,426.61,209.67 z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M437.65,240.99c6.31,8.59,4.73,23.07,4.73,27.99c0,0.62-0.26,1.17-0.66,1.59c-0.06,0.07-0.13,0.13-0.2,0.19 c-1.03,0.88-2.68,1-3.18-0.27c-0.51-1.89-5.08-20.3-7.52-28.82c0.21-7.72-1.05-29.74,1.99-32.78c3.33-0.56,6.63-0.63,8.89-0.59 c1.77,0.04,2.9,0.15,2.9,0.15c0.01,0.07,0.03,0.13,0.04,0.2C446.61,218.15,439.53,234.17,437.65,240.99z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M403.85,179.33c-1.46-0.66-1.68-1.62-2.41-2.75c-0.72-1.13-3.86-2.26-5.41-1.79 c-1.55,0.48-2.74,1.26-2.74,1.26c1.51,0.97,3.7,0.2,4.84,1.14c1.14,0.94,1.72,1.39,2.16,1.7c-1.08-0.02-1.72-0.85-2.59-1.15 c-0.87-0.29-1.66-0.75-2-0.07c0.68,0.31,1.81,0.89,2.25,1.23c0.45,0.34,1.68,2.29,2.72,1.94c1.04-0.35,1.9-0.31,2.69,0.08 C404.16,181.33,403.85,179.33,403.85,179.33z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M440.25,167.47c-0.55,1.21-1.67,4.57-0.62,7.09c0.2,0.46-1.02,0.84-2.5,1.03c-0.98,0.12-2.07,0.15-2.94,0.07 c-0.1-0.01-0.21-0.02-0.31-0.03h-0.01c-0.84-0.13-1.39-0.38-1.27-0.81c0.76-2.72,0.41-3.96,0.41-3.96s-1.83,1.1-3.93,0.51 c-2.16-2.58-2.22-5.15-1.69-7.56c0.16-0.71-0.09-1.94-0.21-3.05c-0.07-0.68-0.1-1.32,0.04-1.77c0.06-0.19,0.14-0.36,0.25-0.51 c0.13-0.16,0.72-0.34,1.6-0.48c2.88-0.49,8.85-0.6,11.17,1.75C442.41,161.93,439.44,165.87,440.25,167.47z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M437.65,240.99c6.31,8.59,4.73,23.07,4.73,27.99c0,0.62-0.26,1.17-0.66,1.59 c-0.55-6.28-1.09-12.58-1.63-18.86c-0.21-2.33-0.43-4.73-1.56-6.77c-0.62-1.12-1.5-2.11-1.84-3.34c-0.48-1.74,0.22-3.55,0.84-5.24 c0.84-2.26,1.57-4.57,2.19-6.9c1.13-4.25,1.91-8.6,2.31-12.99c0.19-2.11,0.1-4.27,0.33-6.37c0.14-1.34,1.21-1.85,2.28-1.45 C446.61,218.15,439.53,234.17,437.65,240.99z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 344.5433,
    y1: 2813.062,
    x2: 374.6462,
    y2: 2813.062,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1488.4165 -1919.0056)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#33A1F5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0DE5F0"
    }
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st69",
    d: "M437.13,177.79c0,0-7.14,9.43-15.82,12.06c-10-1.58-13.42-6.39-18.05-8.16c-1.04-0.4-1.19-3.96-0.31-3.68 c4.6,1.43,13.35,3.1,17.98,6.1c2.66-3.09,11.36-11.38,11.36-11.38L437.13,177.79z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.3747,
    y1: 1075.29,
    x2: 437.13,
    y2: 1075.29,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6D3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CABB7"
    }
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st70",
    d: "M437.13,177.79c0,0-7.14,9.43-15.82,12.06c-10-1.58-13.42-6.39-18.05-8.16c-1.04-0.4-1.19-3.96-0.31-3.68 c4.6,1.43,13.35,3.1,17.98,6.1c2.66-3.09,11.36-11.38,11.36-11.38L437.13,177.79z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M440.24,166.69c-0.55,1.21-1.67,4.57-0.62,7.09c0.2,0.46-1.02,0.84-2.5,1.03c-0.98,0.12-2.07,0.15-2.94,0.07 c-0.32-0.84-0.2-1.86-0.05-2.78c0.28-1.82,0.57-3.65,0.85-5.48c0.21-1.33,0.39-2.81-0.38-3.92c-0.74-1.06-2.12-1.43-3.4-1.59 c-1.29-0.17-2.64-0.23-3.74-0.91c-0.1-0.06-0.2-0.14-0.29-0.22c-0.07-0.68-0.1-1.32,0.04-1.77c0.06-0.19,0.14-0.36,0.25-0.51 c0.13-0.16,0.72-0.34,1.6-0.48c2.88-0.49,8.85-0.6,11.17,1.75C442.4,161.15,439.43,165.09,440.24,166.69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.7631,
    y1: 2827.7227,
    x2: 389.6618,
    y2: 2827.7227,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1492.4453 -1908.2991)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6D3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CABB7"
    }
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st72",
    d: "M444.84,209.92c-0.59,5.85-18.47,4.66-18.23-0.25c2.28-8.24,2.77-9.97-1.68-21.8 c-1.91-5.09,3.59-11.06,7.37-15.47l3.65-0.08l4.1-0.08c0.19,4.13,4.83,3.94,2,16.05c-1.97,8.45-0.23,12.83,1.39,16.29 C444.45,206.68,445.07,207.64,444.84,209.92z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M430.35,206.91c-0.74,0.28-1.69,0.42-1.69,0.42c-0.84-0.35-2.61-0.9-3.28-0.5 c-0.67,0.39-1.14,1.29-1.75,1.68c0.77,0.62,1.92-0.35,2.48-0.68c0.82,0.5,1.7,0.18,1.77,0.35c-0.86,0.17-2.74,1.68-4.49,1.5 s-3.3,0.09-3.39,0.59c1.89,1.48,2.39,2.84,4.06,2.62c1.67-0.22,3.64,0.62,4.91-1.38c0.58-1.78,0.98-1.92,1.54-2.34 s1.9-0.99,1.9-0.99L430.35,206.91z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 444.2129,
    y1: 1071.9153,
    x2: 435.3379,
    y2: 1104.2903,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B6D3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8CABB7"
    }
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st73",
    d: "M448.21,198.2c-7.95,6.08-12.31,10.41-16.61,11.07c-0.16-0.18-0.32-0.36-0.47-0.53 c-0.91-1.08-1.5-2.12-0.62-2.69c1.01-0.44,8.64-9.26,12.64-10.65c-0.94-1.94-5.19-10.46-7.35-14.57c-1.87-3.56-0.9-5.84,1.23-6.51 c0.32-0.1,0.66-0.07,0.99-0.03C444.61,175.04,450.14,196.57,448.21,198.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 368.4774,
    y1: 2801.3379,
    x2: 386.3162,
    y2: 2801.3379,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -1477.5259 -1912.2968)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3726,
    style: {
      stopColor: "#020202"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5069,
    style: {
      stopColor: "#090807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6026,
    style: {
      stopColor: "#141311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#25221F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7463,
    style: {
      stopColor: "#3B3730"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    style: {
      stopColor: "#574F47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8581,
    style: {
      stopColor: "#776D61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9069,
    style: {
      stopColor: "#9D9080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9523,
    style: {
      stopColor: "#C8B7A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9926,
    style: {
      stopColor: "#F6E2C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEAD0"
    }
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M425.87,157.47c0.39-5.49,6.97-7.03,11.37-3.23c2.44-0.81,5.18,0.99,6.31,3.91 c1.12,2.93,0.29,5.17-1.12,9.83c-1.44,4.74,0.36,6.94,3.38,12.97c-5.91,5.31-10.86-3.64-11.09-6.4c-0.22-2.76,3.09-9.2,2.15-11.32 s-2.81-6.04-6.44-4.52C426.81,160.24,425.87,157.47,425.87,157.47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: -667.9253,
    y1: 2531.3765,
    x2: -644.6685,
    y2: 2531.3765,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -555.6494 -2268.7532)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42934D"
    }
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M361.92,199.43c-7.97-1.4-8.13-5.53-8.13-5.53c1.15,0.05,2.51-1.38,2.51-1.38 c-1.56-0.04-1.72,0.13-3.2,0.09c-0.62-1.79-1.43-6.2-0.3-10.76c1.06-0.19,2.35-1.22,2.35-1.22s-0.92,0.27-2.64,0.07 c-0.02-1.15-1.15-3.99-0.69-6.2c0.55-2.65,1.55-4.75,1.55-4.75c1.4,0.29,3.32,1.14,3.32,1.14s-3-1.64-3.76-2.12 c0.86-1.42,1.95-3.92,3.51-6.92c1.94,1.67,4.03,3.17,5.91,5.59l-1.98,2.69l2.98-2.3c1.24,1.27,1.95,4.43,3.95,7.74 c1.58,2.62,1.57,6.14,1.42,8.96c-1.95,0.82-3.74,1.53-3.74,1.53c2.14-0.06,4.6-0.02,4.6-0.02c-0.4,1.38-0.99,7.69-1.99,9.26 c-1.72,2.68-4.06,3.89-4.98,4.11L361.92,199.43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: -684.0825,
    y1: 2563.9907,
    x2: -630.1787,
    y2: 2563.9907,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -574.702 -2264.2854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F97AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CFE7FC"
    }
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M358,260.29c-1.64-1.52-6.12-8.71-5.16-21.48c0.27-3.55,2.15-7.53,4.54-12.56 c1.69-3.56,3.6-7.59,5.39-12.4c0.75-2.02,0.36-4.16-0.06-6.43c-0.22-1.18-0.44-2.4-0.49-3.59c-0.06-1.71,0.18-3.42,0.41-5.07 c0.11-0.8,0.23-1.63,0.31-2.44c0.42-4.27-0.12-8.59-0.65-12.77c-0.41-3.29-2.2-8.51-3.63-12.71c-0.65-1.92-1.22-3.57-1.58-4.8 l0.48-0.14c0.35,1.22,0.92,2.87,1.57,4.78c1.44,4.21,3.23,9.46,3.65,12.81c0.53,4.21,1.07,8.56,0.65,12.88 c-0.08,0.83-0.2,1.66-0.31,2.46c-0.23,1.63-0.47,3.32-0.41,4.98c0.04,1.16,0.26,2.36,0.48,3.52c0.41,2.23,0.84,4.54,0.04,6.7 c-1.8,4.83-3.72,8.87-5.41,12.44c-2.36,4.98-4.23,8.92-4.49,12.38c-1.1,14.74,4.94,21.02,5,21.07L358,260.29z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: -682.658,
    y1: 2577.1963,
    x2: -648.8884,
    y2: 2577.1963,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -586.6934 -2270.469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#005000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#42934D"
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M364.63,219.58c0.17,1.25-3.44,10.77-6.72,9.83s2.34-5.93,3.28-9.24c0.94-3.31-1.06-5.9-5.56-7.39 c0.68,2.26,1.19,8.98-2.09,8.29s-2.17-3.63-0.16-9.12c1.03-2.81-2.18-3.3-5.62-5.4c0-0.53-0.29,2.8,0.94,5.89 c1.35,3.42-2.77,4.73-3.61,1.11c-0.72-3.14-0.24-5.61-4.61-6.84s-6.77-1.99-6.77-1.99c1.56,2.17-1.72,8.21-0.45,11.13 c0.82,1.89,3.72,2.14,5.15,3.77c2.29,2.62,2.06,4.17,0.85,5.32c-1.15,1.1-4.19,1.01-6.97-3.77c-1.41,1.69-1.54,7.91,1.27,10.4 c2.81,2.49,7.01,0.61,10.21,0.3c2.55-0.24,3.96,2.79,2.19,4.01c-4.67,3.22-6-1.35-9.75,0.21c0.81,5.97,5.96,7.28,9.68,7.57 c3.69,0.29,8.75-3.08,10.15-5.28l0.34-0.14c1.87,0.62,6.06,0.74,9.22-2.85C368.76,231.83,369.3,225.82,364.63,219.58z  M344.11,229.91c-0.93,0.79-2.43,0.79-3.37,0.01c-0.38-0.31-0.67-0.8-0.57-1.28c0.33-1.51,2.32-1.16,3.32-0.82 c0.48,0.16,1.02,0.42,1.15,0.91C344.74,229.17,344.45,229.62,344.11,229.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: -671.3536,
    y1: 2583.9941,
    x2: -660.4642,
    y2: 2583.9941,
    gradientTransform: "matrix(0.8192 -0.5736 0.5736 0.8192 -587.8458 -2266.5896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7F97AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CFE7FC"
    }
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M358.34,255.09c-0.1,0-0.2-0.06-0.23-0.17c-1.07-3.26-1.07-6.82-1.07-10.25c0-4.43,0-8.61-2.08-12.27 c-1.58-2.78-4.18-4.81-6.71-6.77c-2.29-1.79-4.66-3.64-6.32-6.06c-0.94-1.38-1.62-2.91-2.29-4.4c-0.65-1.46-1.33-2.97-2.24-4.3 c-0.08-0.11-0.05-0.26,0.06-0.33c0.11-0.08,0.26-0.05,0.33,0.06c0.93,1.37,1.61,2.9,2.28,4.38c0.66,1.47,1.34,2.98,2.25,4.32 c1.61,2.36,3.95,4.19,6.21,5.95c2.56,1.99,5.21,4.06,6.83,6.91c2.14,3.77,2.14,8.21,2.14,12.51c0,3.4,0,6.91,1.04,10.1 c0.04,0.13-0.03,0.26-0.15,0.3C358.39,255.08,358.36,255.09,358.34,255.09z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.4149,
    y1: 1160.6851,
    x2: 372.9583,
    y2: 1160.6851,
    gradientTransform: "matrix(1 0 0 1 0 -894.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AED3C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#83ABB8"
    }
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M372.1,253.95h-24.82c-0.54,0-0.95,0.5-0.85,1.03l0.66,3.44c0.08,0.41,0.44,0.7,0.85,0.7h0.45l4.17,19.59 c0.09,0.41,0.45,0.71,0.87,0.71h12.51c0.42,0,0.79-0.29,0.87-0.71l4.17-19.59h0.45c0.42,0,0.77-0.29,0.85-0.7l0.66-3.44 C373.05,254.44,372.65,253.95,372.1,253.95z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionBpm);
export default __webpack_public_path__ + "static/media/solutionBPM.e318ca20636246ed375032c3af54dbcf.svg";
export { ForwardRef as ReactComponent };